import script from "./FastCopyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FastCopyPage.vue?vue&type=script&setup=true&lang=js"

import "./FastCopyPage.vue?vue&type=style&index=0&id=07d1aa04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d1aa04"]])

export default __exports__